export function upsert<T>(existingArray: T[], newElement: T, keyProperty = 'id', sequenceProperty = null): T[] {
    const id = newElement[keyProperty];
    const existing = existingArray.find((e) => e[keyProperty] === id);
    if (existing && sequenceProperty) {
        if (existing[sequenceProperty] > newElement[sequenceProperty]) {
            return [ ...existingArray ];
        }
    }
    return existing ?
        existingArray.map(e => e[keyProperty] === id ? { ...e, ...newElement } : { ...e })
        : [ ...existingArray, newElement ];
}

export function upsertIf<T>(existingArray: T[], newElement: T, keyProperty = 'id', canReplace): T[] {
    const id = newElement[keyProperty];
    const existing = existingArray.find((e) => e[keyProperty] === id);
    if (existing) {
        if (!canReplace(existing, newElement)) {
            return [ ...existingArray ];
        }
    }
    return existing ?
        existingArray.map(e => e[keyProperty] === id ? { ...e, ...newElement } : { ...e })
        : [ ...existingArray, newElement ];
}

export function unique<T>(array: T[]): T[] {
    return [ ...new Set(array) ];
}

export function toggle<T>(array: T[], item: T): T[] {
    return array.indexOf(item) === -1 ? [ ...array, item ] : array.filter(e => e !== item);
}

export function removeAt(array: any[], index: number): any[] {
    const newArray = [ ...array ];
    newArray.splice(index, 1);
    return newArray;
}

